export default __webpack_public_path__ + "static/media/instagram.bb28f596.svg";